export function debounce(func, wait, immediate) {
    var timeout;

    return function() {
        const context = this;
        const args = arguments;
        const callNow = immediate && !timeout;
        const later = function() {
            timeout = null;

            if(!immediate) {
                func.apply(context, args);
            }
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if(callNow) {
            func.apply(context, args);
        }
    };
}

export function browserDetails() {
    const ua = navigator.userAgent;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    let tem;
    let mobile = ua.match(/(Mobile|mobile)/);

    if(/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {
            name: 'IE',
            version: (tem[1] || '')
        };
    }

    if(M[1] === 'Chrome') {
        tem = ua.match(/\b(?:OPR|Edge)\/(\d+)/);

        if(tem != null) {
            return {
                name: 'Opera',
                version: tem[1]
            };
        }
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }

    return {
        name: M[0],
        version: parseFloat(M[1], 10),
        mobile: mobile !== null
    };
}

export const isString = (value) => {
    return typeof value === 'string';
};

export const isBoolean = (value) => {
    return typeof value === 'boolean';
};

export const isObject = (value) => {
    return typeof value === 'object';
};

export const has = (object, key) => {
    return isObject(object) && object.hasOwnProperty(key);
};

export const get = (object, key, defaultValue) => {
    return has(object, key) ? object[key] : defaultValue;
};

export const px = value => {
    return `${value}px`;
};

export const translate = (x, y) => {
    return `translate(${x}, ${y})`;
};



// WEBPACK FOOTER //
// ./src/app/utils/aha-utils.js